<template>
  <div class="bb-search-vendor-tag">
    <div class="bb-search-vendor-tag-container">
      <i class="icon-search bb-search-vendor-tag-container__icon"/>
      <div class="bb-search-vendor-tag-container__input bb-input bb-input_search"
           :class="{'bb-search-vendor-tag-container__input_tag': filterByTags.length}"
      >
        <input
            v-if="!searchByHashtag"
            :value="vendorSearch"
            class="bb-search-vendor-tag-container__input_border"
            type="text"
            @input="inputSearch"
            :placeholder="filterByTags.length ? '' : 'Search'"
        />
        <div v-else
             class="bb-search-vendor-tag-container__tag"
             v-for="filterTag in filterByTags"
             :key="filterTag.id"
             @click="clearFilterTag(filterTag)"
        >
          {{filterTag.name}}
        </div>
      </div>
      <span class="bb-search-vendor-tag-container-select"
            @click="openSelectSearch = !openSelectSearch"
      >
      <span class="bb-search-vendor-tag-container-select__title">{{searchBySelect}}</span>
      <i class="icon-arrow-select bb-search-vendor-tag-container-select__icon"
         :class="{'bb-search-vendor-tag-container-select__icon_active': openSelectSearch}"/>
      <transition name="b-bonce">
        <span class="bb-search-vendor-tag-container-options"
              v-if="openSelectSearch"
              @mouseleave="openSelectSearch = false"
        >
          <span class="bb-search-vendor-tag-container-options__item"
                v-for="option in searchOptions"
                :key="option"
                @click="setTypeSearch(option)"
          >
            {{option}}
          </span>
        </span>
      </transition>
    </span>
    </div>
    <transition name="bb-fade-options">
      <VuePerfectScrollbar class="bb-search-vendor-tag-body"
                           :class="{'bb-search-vendor-tag-body_start': scrollInStart}"
                           v-if="searchByHashtag"
                           @ps-scroll-x="setScrollPosition"
                           v-dragscroll
      >
        <div class="bb-search-vendor-tag-body__tag"
             :class="{'bb-search-vendor-tag-body__tag_selected': selectedTag(tag)}"
             v-for="tag in fullTagList"
             :key="tag.id"
             @click="setFilterByTag(tag)"
        >
          {{tag.name}}
        </div>
      </VuePerfectScrollbar>
    </transition>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VendorTagsApi from '@/api/VendorTags/api'
import {debounce} from 'lodash'
import {dragscroll} from 'vue-dragscroll'
export default {
  name: 'SearchVendorTag',
  components: {
    VuePerfectScrollbar
  },
  directives: {
    dragscroll
  },
  computed: {
    searchByHashtag () {
      return this.searchBySelect === 'hashtag'
    },
    searchDebounceTag () {
      return debounce(this.searchTag, 1000)
    },
    setDebounceSearch () {
      return debounce(this.setSearch, 500)
    },
    vendorTags: {
      get: function () {
        return this.$store.getters.vendorTags
      },
      set: function (data) {
        this.$store.dispatch('setVendorTags', data)
      }
    },
    vendorTagsFilter: {
      get: function () {
        return this.$store.getters.vendorTagsFilter
      },
      set: function (data) {
        this.$store.dispatch('setFilterVendorTag', data)
      }
    },
    vendorSearch: {
      get: function () {
        return this.$store.getters.vendorSearch
      },
      set: function (data) {
        this.$store.dispatch('setSearchVendor', data);
      }
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    }
  },
  data () {
    return {
      openSelectSearch: false,
      searchBySelect: 'name',
      searchOptions: ['name', 'hashtag', 'Services/Goods'],
      scrollInStart: true,
      filterByTags: [],
      fullTagList: [],
    }
  },
  methods: {
    setTypeSearch (type) {
      this.filterByTag = []
      this.searchBySelect = type
      if (type === 'name') {
        const search = this.$refs.bbInputSearch
        if (search) search.value = ''
      }
      if (type === 'hashtag') {
        this.getTagsVendor()
      }
      this.$store.dispatch('setTypeSearchVendor', type);
    },
    setScrollPosition (e) {
      const scrollLeft = e.srcElement.scrollLeft
      this.scrollInStart = !scrollLeft
    },
    setFilterByTag (tag) {
      const tagIndex = this.filterByTags.find(item => item.id === tag.id)
      if (!tagIndex) {
        this.filterByTags.push(tag)
        this.fullTagList = this.vendorTags
        this.vendorTagsFilter = this.filterByTags
      }
    },
    inputSearch (e) {
      const { value } = e.target
      if (this.searchByHashtag) {
        this.filterByTags = []
        this.searchDebounceTag(value)
      } else {
        this.setDebounceSearch(value)
      }
    },
    searchTag (val) {
      if (!val) {
        this.fullTagList = this.vendorTags
        return
      }
      const regForFilter = new RegExp(val, 'gmi')
      const result = this.vendorTags.filter(tag => {
        regForFilter.lastIndex = 0
        return regForFilter.test(tag.name)
      })
      const regForSort = new RegExp('^' + val, 'gmi')
      this.fullTagList = result.sort((a, b) => {
        regForSort.lastIndex = 0
        return regForSort.test(b.name) - regForSort.test(a.name)
      })
    },
    setSearch (val) {
      this.vendorSearch = val.toLowerCase().trim()
    },
    selectedTag (tag) {
      return this.filterByTags.some(item => item.id === tag.id)
    },
    clearFilterTag (tag) {
      const indexObject = this.filterByTags.findIndex(item => item.id === tag.id)
      if (indexObject > -1) {
        this.filterByTags.splice(indexObject, 1)
        this.vendorTagsFilter = this.filterByTags
        this.fullTagList = this.vendorTags
      }
    },
    getTagsVendor () {
      VendorTagsApi.getVendorTags()
        .then((resp) => {
          this.vendorTags = resp.data
          this.fullTagList = this.vendorTags
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";
@import "../../../../../sass/mixins";

.bb-search-vendor-tag {
  @include global-font;
  max-width: 596px;
  width: 100%;
  position: relative;
  border: 1px solid $color-wild-sand;
  border-radius: 6px;

  &-body {
    position: absolute;
    width: 100%;
    margin-top: 8px;
    height: 37px;
    padding: 0 22px;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    background: $color-white;
    display: inline-flex;
    align-items: center;
    overflow: hidden;

    &_start {
      &:before {
        display: none;
      }
    }

    &__tag {
      padding: 3px 5px;
      margin-right: 8px;
      border-radius: 4px;
      color: $color-accent;
      background-color: $color-link-water;
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      white-space: nowrap;
      user-select: none;
      transition: 0.3s;
      cursor: pointer;

      &_selected {
        color: $color-silver;
        background: rgba($color-silver-chalice, 0.2);
      }

      &:hover {
        color: $color-accent-hover;
      }
    }
  }

  &-container {
    display: flex;
    align-items: center;

    &__tag {
      padding: 4px 8px;
      margin-right: 8px;
      color: $color-accent;
      border-radius: 4px;
      background-color: $color-link-water;
      font-size: 13px;
      line-height: 16px;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        color: $color-accent-hover;
      }
    }

    &__input {
      width: 100%;
      height: 42px;
      border-radius: 6px;
      padding-left: 40px;

      &_tag {
        display: flex;
        padding: 9px 9px 9px 45px;
      }

      &_border {
        width: 100%;
        border: none;
        font-size: 14px;
        line-height: 17px;
        color: $color-text;

        &::placeholder {
          @include global-font-light;
          color: $color-silver;
        }
      }
    }

    &__icon {
      position: absolute;
      left: 13px;
      font-size: 15px;
      z-index: 2;
      color: $color-silver;
    }

    &-select {
      position: absolute;
      display: flex;
      align-items: center;
      right: 14px;
      transition: 0.3s;
      cursor: pointer;
      color: $color-accent;

      &:hover {
        color: $color-accent-hover;
      }

      &__title {
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
      }

      &__icon {
        font-size: 5px;
        margin-left: 4px;
        transition: 0.3s;

        &_active {
          transform: rotate(180deg);
        }

        &_settings {
          font-size: 14px;
          margin-left: 1px;
        }
      }
    }

    &-options {
      position: absolute;
      top: 20px;
      right: 0;
      display: grid;
      grid-gap: 8px;
      box-shadow: 0 0 15px rgba($color-black, 0.08);
      border-radius: 4px;
      background-color: $color-white;
      padding: 16px 12px;
      z-index: 2;

      &__item {
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        color: $color-black;
        transition: 0.3s;

        &:hover {
          color: $color-accent;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/SearchVendorTag/SearchVendorTag.vue